import React from "react";
import { ShieldCheck } from "lucide-react";

export default function AnonymityNotice({ context = "rfq" }) {
  const text = context === "quote"
    ? "Buyer identity is hidden. Don't include your company name, email, phone, or website in remarks — submission will be blocked."
    : context === "message"
    ? "Pre-award messaging is platform-relayed. Direct contact details are auto-rejected."
    : "Supplier identities are hidden until award. Don't include phone, email, or company names in notes / spec — submission will be blocked.";
  return (
    <div className="card" style={{ padding: 12, marginBottom: 16, borderLeft: "3px solid var(--amber-500)", display: "flex", gap: 10, alignItems: "center", background: "rgba(245,158,11,0.04)" }}>
      <ShieldCheck size={16} color="var(--amber-500)" />
      <div style={{ fontSize: 12, color: "var(--ink-dim)", lineHeight: 1.5 }}>{text}</div>
    </div>
  );
}
